<template>
    <div><!-- 帳款查詢 -->
        <SearchBar  @accountSearch="doAccountSearch" />
        <CCard>
            <CCardBody>
                <div class="table-container" style="overflow-x:auto;">
                    <vue-bootstrap4-table ref="accountSearchBs4Table" class="" 
                        :rows="accountSearchResult" 
                        :columns="columns" 
                        @on-change-query="onChangeQuery"
                        :total-rows="totalCount"
                        :config="config" :classes="classes" >
                        <template v-if="isTw" slot="empty-results">
                            查無結果
                        </template>
                        <template v-if="isTw" slot="pagination-info" slot-scope="props">
                            {{paginationInfoTwText(props)}}
                        </template>
                    </vue-bootstrap4-table>
                </div>
            </CCardBody>
        </CCard>
    </div>
</template>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}
</style>
<script>
import SearchBar from './SearchBar'
import { orderMixin } from '@/mixin/order'
import { mapGetters } from 'vuex'
export default {
    mixins: [orderMixin],
    data() {
        return {
            columns: [
                { label: this.i18n('AccountQuery.InvoiceDate'), name: "bldat"},
                { label: this.i18n('AccountQuery.PostingDate'), name: "budat"},
                { label: "帳款性質",name: "aptype"},
                { label: this.i18n('AccountQuery.VendorCode'), name: "lifnr"},
                { label: this.i18n('AccountQuery.Vendor'),name: "name1"},
                { label: this.i18n('AccountQuery.Currency'),name: "waers"},
                { label: this.i18n('AccountQuery.TaxCode'),name: "mwskz"},
                { label: this.i18n('AccountQuery.Tax'),name: "kbetr"},
                { label: this.i18n('AccountQuery.ExchRate'),name: "kursf"},
                { label: this.i18n('AccountQuery.NetAmountInLocalCurrency'),name: "wrbtr3"},
                { label: this.i18n('AccountQuery.AmountInLocalCurrency'),name: "wrbtr1"},
                { label: this.i18n('AccountQuery.PaymentAmountInLocalCurrency'),name: "wrbtr4"},
                { label: this.i18n('AccountQuery.NotPaymentAmountInLocalCurrency'),name: "wrbtr5"},
                { label: this.i18n('AccountQuery.DueOn'),name: "zfbdt"},
                { label: this.i18n('AccountQuery.Reference'),name: "xblnr"},
                { label: this.i18n('AccountQuery.PaymentStatus'),name: "zpaySt" ,column_classes: 'text-danger'},
                { label: this.i18n('AccountQuery.Memo'),name: "sgtxt"}
                
            ],
            headers : [
                "發票日期","過帳日期","帳款性質","廠商編號","供應廠商","幣別",
                "稅碼","稅率","匯率","原幣未稅金額","原幣含稅金額","原幣已付金額",
                "原幣未付金額","到期日","發票號碼","付款狀態","備註"
            ],
            classes: {
                cell : {                    
                    "text-danger" : function(row,column) {
                        return column.name == "zpaySt" 
                    }
                }
            },
            accountSearchResult : [],
            totalCount: 0,
            accountQueryParam: {},     
        }
    },
    components: {
        SearchBar,
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.columns = [
                { label: this.i18n('AccountQuery.InvoiceDate'), name: "bldat"},
                { label: this.i18n('AccountQuery.PostingDate'), name: "budat"},
                { label: "帳款性質",name: "aptype"},
                { label: this.i18n('AccountQuery.VendorCode'), name: "lifnr"},
                { label: this.i18n('AccountQuery.Vendor'),name: "name1"},
                { label: this.i18n('AccountQuery.Currency'),name: "waers"},
                { label: this.i18n('AccountQuery.TaxCode'),name: "mwskz"},
                { label: this.i18n('AccountQuery.Tax'),name: "kbetr"},
                { label: this.i18n('AccountQuery.ExchRate'),name: "kursf"},
                { label: this.i18n('AccountQuery.NetAmountInLocalCurrency'),name: "wrbtr3"},
                { label: this.i18n('AccountQuery.AmountInLocalCurrency'),name: "wrbtr1"},
                { label: this.i18n('AccountQuery.PaymentAmountInLocalCurrency'),name: "wrbtr4"},
                { label: this.i18n('AccountQuery.NotPaymentAmountInLocalCurrency'),name: "wrbtr5"},
                { label: this.i18n('AccountQuery.DueOn'),name: "zfbdt"},
                { label: this.i18n('AccountQuery.Reference'),name: "xblnr"},
                { label: this.i18n('AccountQuery.PaymentStatus'),name: "zpaySt" ,column_classes: 'text-danger'},
                { label: this.i18n('AccountQuery.Memo'),name: "sgtxt"}
                
            ]
        }
    },
    methods: {
        doAccountSearch (queryParam){// 帳款 查詢
            const url = `${this.$apiUrl_Order}/SearchAccountPageAsync`
            const param= queryParam;
            const self =this;
            const currencyFilter = this.$options.filters['currency'];
            const currencyF2Filter = this.$options.filters['currencyF2'];
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                
                    //--成功                    
                    const resp =response.data;
                    resp.rows.forEach(r => {
                        //--日期處理
                        r.bldat = self.fixDate(r.bldat);
                        r.budat = self.fixDate(r.budat);
                        r.zfbdt = self.fixDate(r.zfbdt);

                        //--金額處理
                        //--Fxi by 厚任 Email  2022/03/18 11:19
                        r.wrbtr3 = currencyF2Filter(r.wrbtr3);//原幣未稅金額
                        r.wrbtr1 = currencyF2Filter(r.wrbtr1);//原幣含稅金額
                        r.wrbtr4 = currencyF2Filter(r.wrbtr4);//原幣已付金額
                        r.wrbtr5 = currencyF2Filter(r.wrbtr5);//原幣未付金額

                        //稅率(kbetr)
                        if(r.kbetr || r.kbetr === 0 ){
                            r.kbetr = currencyF2Filter(r.kbetr) + '%';
                        }
                    });
                    self.accountSearchResult = resp.rows; 
                    self.totalCount = resp.totalCount;
                    self.accountQueryParam = param;                    
                    self.setCacheQueryParam('Account_QueryParam' , param);
                }                    
            });
        },
        onChangeQuery (queryParams){
            let search =  this.accountQueryParam;
            search.pageSize=queryParams.per_page;
            search.pageIndex=queryParams.page;                 
            this.doAccountSearch(search);        
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"])
    },
	mounted() {
	},
    created() {        
    }
}
</script>

